import React, { Fragment } from "react";
import {
  Button,
  CircularProgress,
  withWidth,
  withStyles,
  withTheme,
} from "@material-ui/core";
import {
  AddRounded as AddRoundedIcon,
  Cancel as CancelIcon,
  Edit as EditIcon,
  KeyboardArrowDown as ArrowDropDown,
  OpenInNew as UndockIcon,
} from "@material-ui/icons";
import Select from "react-select";
import { compose } from "recompose";
import appConstant from "../appConstants";
import { RMAXLogger } from "../services/LoggerService/RMAXLogger";
import MapDrawinToolBox from "../components/mapComponents/Drawing/DrawingToolbox";
import { withUserProfile } from "../userProfile/userProfileContext";
import Tooltip from "./../components/common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import styles from "./componentHeaderStyles";
import PopInIcon from "./icons/PopIn";
import TSPIcon from "./icons/TSP";
import PrintMenu from "./layoutHeader/printComponent";
import ShowHideColumns from "./layoutHeader/showHideColumns";
import {withFeatureFlags} from "../userProfile/featureFlagsContext"
import {SearchBar} from './layoutHeader/components';
import {
  DispatchStartEndTrip,
  Messages,
  EquipmentDefects,
  CreateDispatch,
  CancelDispatch
} from '../components/modules/Dispatch/RouteExecution/Drivers/GridHeaderControls';
import ExportData from './layoutHeader/components/ExportData';
import FullScreen from './layoutHeader/components/FullScreen';
import WatchTutorial from "../components/InAppTutorial/WatchTutorial";
import MergeStops from "./layoutHeader/components/MergeStops";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
import Refresh from "./layoutHeader/components/Refresh";

class GLComponentHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMaximised: false,
      activeIndex: 0,
      headerIndex: this.props.stackIndex,
      enableMergeRoutes: false,
      enableTSP: false,
      showEditMode: false,
      enableEdit: false,
      enableGeocode: false,
      isSaveButtonDisabled: false,
      isRouteAnimationEnabled: true,
      isMapLegendEnabled: false,
      updateMessage: null,
    };
    this.editorRef = {};
    this.headerConfig =
      this.props.stack.config.content[this.props.stackIndex].gridHeader || {};
    this.headerId = this.props.headerId;
    this.componentRef = React.createRef();
    this.isSubWindow = this.props.stack.layoutManager.isSubWindow;
  }

  componentDidMount() {
    if (this.headerConfig && this.headerConfig.showTSP) {
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_EnableTSP`,
        this.enableTSP
      );
    }
    if (this.headerConfig && this.headerConfig.showMergeRoutes) {
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_EnableMergeRoutes`,
        this.enableMergeRoutes
      );
    }

    if (this.headerConfig && this.headerConfig.showEdit) {
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_DisableEditSave`,
        this.disableEditSave
      );
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_showEditMode`,
        this.showEditMode
      );
    }

    this.props.stack.layoutManager.eventHub.on(
      `${this.headerId}_updateMessage`,
      this.updateMessage
    );
    this.props.stack.layoutManager.eventHub.on(
      `${this.headerId}_setGridApi`,
      this.setGridApi
    );
    this.props.stack.layoutManager.eventHub.on(
      `${this.headerId}_activateTab`,
      this.activeIndexChanged
    );
    this.props.stack.on("activeContentItemChanged", this.hideShowHeader);
  }

  componentWillUnmount() {
    if (this.headerConfig && this.headerConfig.showTSP) {
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_EnableTSP`,
        this.enableTSP
      );
    }
    if (this.headerConfig && this.headerConfig.showMergeRoutes) {
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_EnableMergeRoutes`,
        this.enableMergeRoutes
      );
    }
    if (this.headerConfig && this.headerConfig.showEdit) {
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_DisableEditSave`,
        this.disableEditSave
      );
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_showEditMode`,
        this.showEditMode
      );
    }

    this.props.stack.layoutManager.eventHub.off(
      `${this.headerId}_updateMessage`,
      this.updateMessage
    );
    this.props.stack.layoutManager.eventHub.off(
      `${this.headerId}_setGridApi`,
      this.setGridApi
    );
    this.props.stack.layoutManager.eventHub.off(
      `${this.headerId}_activateTab`,
      this.activeIndexChanged
    );
    this.props.stack.off("activeContentItemChanged", this.hideShowHeader);

    if (this.state.gridApi) {
      this.state.gridApi.removeEventListener(
        "selectionChanged",
        this.onGridSelectionChanged
      );
      this.state.gridApi.removeEventListener(
        "rowDataChanged",
        this.onGridSelectionChanged
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.showEditMode &&
      this.state.selectedField?.value === 'holidays' &&
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.setState({
        showEditMode: false
      });
    }
  }

  activeIndexChanged = (configId) => {
    let contentItem = this.props.stack.contentItems[0];
    if (configId) {
      contentItem =
        this.props.stack.contentItems.find(
          (contentItem) => contentItem.config.id === configId
        ) || contentItem;
    }
    this.props.stack.setActiveContentItem(contentItem);
  };

  openMainMenu = (event) => {
    this.setState({ mainMenuAnchor: event.currentTarget });
  };

  closeMainMenu = () => {
    this.setState({ mainMenuAnchor: null });
  };

  hideShowHeader = (component) => {
    this.setState({
      activeIndex: component.parent.config.activeItemIndex,
      isMaximised: this.props.stack.isMaximised,
    });
  };

  setGridApi = (api) => {
    this.setState(
      {
        gridApi: api,
      },
      this.onGridSelectionChanged
    );
    api.addEventListener("selectionChanged", this.onGridSelectionChanged);
    api.addEventListener("rowDataChanged", this.onGridSelectionChanged); // needed when shipments are moved from UNRTD to other route i.e when grid becomes empty
  };

  onGridSelectionChanged = () => {
    const selectedRows = this.state.gridApi.getSelectedRows();
    let selectedRowCount = selectedRows.length;
    if (this.props.headerId.includes(appConstant.gridNames.RoutesGrid)) {
      selectedRowCount = this.state.gridApi
        .getSelectedRows()
        .filter(
          (route) => route.routeName !== appConstant.UNRTD_ROUTENAME
        ).length;
    }

    this.setState({
      enableEdit: Boolean(selectedRowCount),
      enableGeocode: selectedRowCount === 1,
    });
  };


  updateMessage = (message) => {
    this.setState({
      updateMessage: message,
    });
  };

  enableTSP = (enableTSP) => {
    this.setState({
      enableTSP,
    });
  };

  enableMergeRoutes = (enable) => {
    this.setState({
      enableMergeRoutes: enable,
    });
  };

  toggleRouteAnimation = (stack) => {
    this.setState(
      {
        isRouteAnimationEnabled: !this.state.isRouteAnimationEnabled,
      },
      () => {
        this.props.stack.layoutManager.eventHub.emit(
          "routeAnimation",
          this.state.isRouteAnimationEnabled
        );
        const eventSpecificData = {
          autoZoomEnabled: this.state.isRouteAnimationEnabled,
        };
        RMAXLogger.info("AutoZoom", eventSpecificData);
      }
    );
  };

  toggleMapLegend = (stack) => {
    this.setState(
      {
        isMapLegendEnabled: !this.state.isMapLegendEnabled,
      },
      () => {
        this.props.stack.layoutManager.eventHub.emit(
          "mapLegend",
          this.state.isMapLegendEnabled
        );
      }
    );
  };

  disableEditSave = (isSaveButtonDisabled) => {
    this.setState({
      isSaveButtonDisabled,
    });
  };

  toggleMaximise = (stack) => {
    stack.toggleMaximise();
    this.setState({
      isMaximised: stack.isMaximised,
    });
    const freshDeskContainer = document.getElementById("freshworks-container");
    if (freshDeskContainer && !this.isSubWindow) {
      freshDeskContainer.style.display = stack.isMaximised ? "none" : "block";
    }
    this.props.stack.layoutManager.eventHub.emit("mapResize");
  };
  popOut = (stack) => {
    const quickFilterContent = this.props.stack.parent.getItemsById(
      appConstant.layout.QuickFilter
    );
    let quickFilterContainer = null;
    let quickFilterwidth = null;
    if (quickFilterContent.length) {
      quickFilterContainer = quickFilterContent[0].container;
      quickFilterwidth = quickFilterContainer.width;
    }

    if (stack.layoutManager.isSubWindow) {
      //stack.layoutManager.emit("popIn");
      window?.close();
    } else {
      stack.popout();
      if (quickFilterContainer) {
        quickFilterContainer.setSize(quickFilterwidth);
      }
    }
    RMAXLogger.info("MultiMonitor");
  };

  runTSP = () => {
    if (this.state.enableTSP) {
      this.setState({
        enableTSP: false,
      });
      this.props.stack.layoutManager.eventHub.emit(`${this.headerId}_runTSP`);
    }
  };

  mergeRoutes = () => {
    if (this.state.enableMergeRoutes) {
      this.props.stack.layoutManager.eventHub.emit(
        `${this.headerId}_mergeRoutes`
      );
    }
  };

  onAfterPrint = () => {
    this.props.stack.layoutManager.eventHub.emit("afterPrintEvent");
  };


  onAddEvent = () => {
    this.props.stack.layoutManager.eventHub.emit("addEvent");
  };

  openEquipmentDefectsModel = () => {
    this.props.stack.layoutManager.eventHub.emit(
      "openDriverGridModel",
      "isEquipmentDefectsModalOpen"
    );
  };

  showEditMode = (showEdit) => {
    if (typeof showEdit !== "boolean") {
      showEdit = !this.state.showEditMode;
    }
    if (this.state.enableEdit || !showEdit) {
      this.setState({
        showEditMode: showEdit,
      });
      let columnOptions = [];
      const columnDefs = this.state.gridApi.getColumnDefs();
      columnOptions = columnDefs
        .filter((colDef) => colDef.bulkEditable || colDef.editable)
        .map((colDef) => ({
          label: colDef.headerName,
          value: colDef.field,
          ...colDef,
        }));
      this.setState({
        columnOptions,
        selectedField: columnOptions[0],
        selectedValue:
          this.state.gridApi.getSelectedRows().length === 1
            ? columnOptions[0]
            : "",
      });
    }
  };

  handleChange = (selectedField) => {
    this.setState({
      selectedField,
    });
  };

  saveEdits = (event) => {
    let editorValue = "";
    if (this.editorRef) {
      if (this.editorRef.getValue) {
        editorValue = this.editorRef.getValue();
      } else if (this.editorRef.current) {
        editorValue = this.editorRef.current.value || "";
      }
    }
    this.props.stack.layoutManager.eventHub.emit(
      `${this.headerId}_BulkUpdate`,
      { field: this.state.selectedField.value, newValue: editorValue }
    );
  };

  geocode = () => {
    if (this.state.enableGeocode) {
      this.props.stack.layoutManager.eventHub.emit(`${this.headerId}_geocode`);
    }
  };

  render() {
    const { classes, stack, theme } = this.props;
    const show = this.state.activeIndex === this.state.headerIndex;
    let EditorFramework = this.state.selectedField?.cellEditor;
    const enableDispatchDriver = this.props.featureFlags.isFeatureEnabled(
      appConstant.features.EnableDispatchDriver
    );
    return (
      <Fragment>
        <div
          className={`${
            show ? classes.showHeader : classes.hideHeader
          } no-print`}
          ref={this.componentRef}
        >
          {this.state.updateMessage && (
            <div className={classes.updateMessage}>
              <CircularProgress size={14} color="primary" />{" "}
              <span>{this.state.updateMessage}</span>
            </div>
          )}
          {this.state.showEditMode && (
            <Fragment>
              <div
                className={`${classes.editControls} ${classes.showEditMode} ${classes.showControl}`}
              >
                <Select
                  value={this.state.selectedField}
                  onChange={this.handleChange}
                  options={this.state.columnOptions}
                  classNamePrefix={"select"}
                  className={classes.reactSelect}
                  menuPlacement="auto"
                  menuPosition="absolute"
                  closeMenuOnSelect
                  components={{
                    DropdownIndicator: (props) => (
                      <ArrowDropDown
                        {...props.innerProps}
                        className={classes.iconStyle}
                      />
                    ),
                  }}
                />

                {EditorFramework && (
                  <div
                    className={`${classes.inputStyle} ${classes.iconLayout} glHeaderIcons`}
                  >
                    <EditorFramework
                      ref={(node) => (this.editorRef = node)}
                      column={{ colDef: this.state.selectedField }}
                      bulkEditContainer
                    />
                  </div>
                )}

                <div
                  className={`${classes.headerIconStyles} ${classes.iconLayout} ${classes.headerButtonContainer} glHeaderIcons `}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.buttonDisabled,
                    }}
                    onClick={this.saveEdits}
                    disabled={this.state.isSaveButtonDisabled}
                  >
                    {this.state.isSaveButtonDisabled ? (
                      <CircularProgress size={16} color="primary" />
                    ) : (
                      "Save"
                    )}
                  </Button>
                </div>

                <div
                  className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
                  onClick={this.showEditMode}
                >
                  <CancelIcon color="primary" />
                </div>
              </div>
            </Fragment>
          )}
          <div
            className={
              this.state.showEditMode
                ? classes.hideControl
                : classes.showControl
            }
          >
            {this.headerConfig?.searchBox && (
              <SearchBar 
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}
            <ClearAllFilterButton gridApi={this.state.gridApi} />

            {this.headerConfig?.equipmentDefects && (
              <EquipmentDefects
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
                handleClick = {this.openEquipmentDefectsModel}
              />
            )}

            {this.headerConfig?.createDispatch && (
              <CreateDispatch
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
                enableDispatchDriver={enableDispatchDriver}
              />
            )}

            {this.headerConfig?.endTrip && (
              <DispatchStartEndTrip
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}
            {this.headerConfig?.cancelDispatch && (
              <CancelDispatch
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}

            {this.headerConfig?.groupMsg && (
              <Messages
                eventHub={this.props.stack.layoutManager.eventHub}
              />
            )}

            {this.headerConfig && this.headerConfig.geocode && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableGeocode
                    ? classes.enabledIcon
                    : classes.disableIcon
                }`}
                onClick={this.geocode}
              >
                <Tooltip
                  title={
                    this.state.enableGeocode
                      ? "Update location"
                      : "Select a single shipment to update location"
                  }
                >
                  <i className={`icon-geocoding ${classes.actionIcon}`} />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.showEdit && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableEdit
                    ? classes.enabledIcon
                    : classes.disableIcon
                }`}
                onClick={this.showEditMode}
              >
                <Tooltip
                  title={
                    this.state.enableEdit
                      ? "Click to Edit"
                      : "Select a row to edit"
                  }
                >
                  <EditIcon />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.showTSP && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableTSP
                    ? classes.tspEnabledIcon
                    : classes.disableIcon
                }`}
                onClick={this.runTSP}
              >
                <Tooltip
                  title={
                    this.state.enableTSP
                      ? "Run sequence optimizer"
                      : "Select Route to run sequence optimizer"
                  }
                >
                  <TSPIcon backgroundColor={this.state.enableTSP ? theme.KPI.KPISingleValue: undefined} />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.showMergeRoutes && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableMergeRoutes
                    ? classes.enableIcon
                    : classes.disableIcon
                }`}
                onClick={this.state.enableMergeRoutes ? this.mergeRoutes : null}
              >
                <Tooltip title="Merge Routes">
                  <i className={`icon-merge-routes ${classes.actionIcon}`} />
                </Tooltip>
              </div>
            )}
            {this.headerConfig?.showMergeStops && (
              <MergeStops
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}

            {this.headerConfig && this.headerConfig.showHideColumn && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
              >
                <ShowHideColumns
                  api={this.state.gridApi}
                  userData={this.props.userData}
                />
              </div>
            )}
            {this.headerConfig && this.headerConfig.addIcon && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
                onClick={this.onAddEvent}
              >
                <Tooltip title="Add">
                  <AddRoundedIcon />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.toggleRouteAnimation && (
              <Tooltip title="Enable/Disable Route Animation">
                <div
                  className={`${classes.toggleAnimationButton} glHeaderIcons`}
                >
                  <div className={classes.toggleText}>
                    {`${
                      this.state.isRouteAnimationEnabled ? "Disable" : "Enable"
                    } Auto Zoom`}
                  </div>
                  <ToggleRenderer
                    value={this.state.isRouteAnimationEnabled}
                    onChange={(e) => this.toggleRouteAnimation(stack)}
                  />
                </div>
              </Tooltip>
            )}

            {this.headerConfig && this.headerConfig.toggleMapLegend && (
              <Tooltip title="Enable/Disable Map Legend">
                <div
                  className={`${classes.toggleAnimationButton} glHeaderIcons`}
                >
                  <div className={classes.toggleText}>
                    {" "}
                    {`${
                      this.state.isMapLegendEnabled ? "Disable" : "Enable"
                    } Map Legend`}{" "}
                  </div>
                  <ToggleRenderer
                    value={this.state.isMapLegendEnabled}
                    onChange={(e) => this.toggleMapLegend(stack)}
                  />
                </div>
              </Tooltip>
            )}

            {this.headerConfig && this.headerConfig.mapTools && (
              <MapDrawinToolBox {...this.headerConfig.mapTools} />
            )}

            {this.headerConfig && this.headerConfig.showExportCSV && (
              <ExportData
                userData={this.props.userData}
                gridApi={this.state.gridApi}
                stack={this.props.stack}
                stackIndex={this.props.stackIndex}
              />            
            )}

            {this.headerConfig?.showRefresh && (
              <Refresh
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
                config={this.headerConfig?.refreshConfig}
              />
            )}

            {this.headerConfig?.print && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
              >
                <PrintMenu
                  stack={this.props.stack}
                  featureFlags={this.props.featureFlags.featureFlags}
                  onAfterPrint={this.onAfterPrint}
                  eventHub={this.props.stack.layoutManager.eventHub}
                />
              </div>
            )}

            {this.headerConfig && this.headerConfig.showTutorial && (
              <WatchTutorial
                eventHub={this.props.stack.layoutManager.eventHub}
                componentId={this.props.stack.config.content[this.props.stackIndex]?.id}
              />
            )}
            <FullScreen toggleFullscreen={() => this.toggleMaximise(stack)} />
            {this.headerConfig && this.headerConfig.showPopout && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
                onClick={(e) => this.popOut(stack)}
                title={this.isSubWindow ? "Pop In" : "Pop Out"}
              >
                {!this.isSubWindow ? <UndockIcon /> : <PopInIcon />}
              </div>
            )}

          </div>
        </div>
      </Fragment>
    );
  }
}
export default compose(
  withWidth(),
  withTheme(),
  withStyles(styles),
  withUserProfile,
  withFeatureFlags
)(GLComponentHeader);
